export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtTymprac';
export const NAME = 'PracovniTym';
